export const formatDateOnlyPtBR = (value) => {
  if (!value) return '-';
  const raw = String(value).trim();
  if (!raw) return '-';

  const parsed = new Date(`${raw}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return '-';
  return parsed.toLocaleDateString('pt-BR');
};

const normalizeUpper = (value) => String(value || '').trim().toUpperCase();
const hasValue = (value) => Boolean(String(value || '').trim());

const resolveFulfillment = (row) => {
  const normalized = normalizeUpper(row?.fulfillment_status || row?.fulfillment);
  return normalized || '';
};

const isCancelType = (row) => normalizeUpper(row?.request_type) === 'CANCEL';

export const isScheduledCancelRequest = (row) => {
  const status = normalizeUpper(row?.status);
  const fulfillment = resolveFulfillment(row);
  const hasScheduledDate = hasValue(row?.scheduled_effective_on);
  const hasProcessedAt = hasValue(row?.scheduled_processed_at);

  return (
    isCancelType(row) &&
    status === 'APPROVED' &&
    fulfillment === 'NOT_STARTED' &&
    hasScheduledDate &&
    !hasProcessedAt
  );
};

export const isScheduledCancelRevoked = (row) => {
  const status = normalizeUpper(row?.status);
  const hasScheduledDate = hasValue(row?.scheduled_effective_on);
  const hasProcessedAt = hasValue(row?.scheduled_processed_at);
  return isCancelType(row) && status === 'CANCELLED' && hasScheduledDate && !hasProcessedAt;
};

export const isScheduledCancelProcessed = (row) => {
  const hasScheduledDate = hasValue(row?.scheduled_effective_on);
  const hasProcessedAt = hasValue(row?.scheduled_processed_at);
  return isCancelType(row) && hasScheduledDate && hasProcessedAt;
};

export const isCancelNoopTerminal = (row) => {
  const fulfillment = resolveFulfillment(row);
  return isCancelType(row) && fulfillment === 'NOOP_TERMINAL';
};

export const getScheduledCancelLifecycleLabels = (row) => {
  if (!isCancelType(row)) return [];

  const labels = [];
  if (isScheduledCancelRequest(row)) labels.push('Cancelamento agendado');
  if (isScheduledCancelRevoked(row)) labels.push('Cancelamento revogado');
  if (isScheduledCancelProcessed(row)) labels.push('Cancelamento processado');
  if (isCancelNoopTerminal(row)) labels.push('No-op terminal');
  return labels;
};

export const isScheduledDowngradeRequest = (row) => {
  const requestType = normalizeUpper(row?.request_type);
  const status = normalizeUpper(row?.status);
  const fulfillment = resolveFulfillment(row);
  const hasScheduledDate = hasValue(row?.scheduled_effective_on);
  const hasProcessedAt = hasValue(row?.scheduled_processed_at);

  return (
    requestType === 'DOWNGRADE' &&
    status === 'APPROVED' &&
    fulfillment === 'NOT_STARTED' &&
    hasScheduledDate &&
    !hasProcessedAt
  );
};

export const buildPlanTransitionLabel = (row) => {
  const current = String(row?.current_plan_code || '').trim() || '-';
  const requested = String(row?.requested_plan_code || '').trim() || '-';
  return `${current} -> ${requested}`;
};

export const resolveScheduledDowngradeSummary = (row) => {
  if (!isScheduledDowngradeRequest(row)) return '-';
  const scheduledDate = formatDateOnlyPtBR(row?.scheduled_effective_on);
  return `Agendado. Efetiva em: ${scheduledDate}. Plano atual permanece ate esta data. Sem cobranca.`;
};

export const matchesAdminScopeFilter = (row, scope) => {
  const normalizedScope = String(scope || '').trim().toLowerCase();
  if (normalizedScope === 'scheduled_downgrade') {
    return isScheduledDowngradeRequest(row);
  }
  if (normalizedScope === 'scheduled_cancel') {
    return isScheduledCancelRequest(row);
  }
  return true;
};
